import { createContext } from "react";

export const PageContext = createContext<any>({});
PageContext.displayName = "PageContext";
